module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-sawit-1.901c0f34.jpeg";